const TermOfUseAction = {
    GET_TERM_OF_USE : "GET_TERM_OF_USE",
    GET_TERM_OF_USE_LOADING : "GET_TERM_OF_USE_LOADING",
    GET_TERM_OF_USE_SUCCESS : "GET_TERM_OF_USE_SUCCESS",
    GET_TERM_OF_USE_FAILED : "GET_TERM_OF_USE_FAILED",
}

export default TermOfUseAction;